import { AdminLayout } from '@/components/Layout';
import InquiryDetails from '../../components/InquiryDetails';


export const ViewInquiry = () => {

  return (
    <AdminLayout title="">
      <div>
       <InquiryDetails />
      </div>
    </AdminLayout>
  );
};
